<template>
  <div>
    <Modal
      v-model="showLoadingModal"
      width="70"
      title="调课处理"
      :footer-hide="true"
      :mask-closable="false"
      @on-visible-change="getModalChange"
    >
      <div class="modal-text">
        <Icon class="loading-icon" type="ios-loading" size="24"></Icon>
        <span>请耐心等待，系统正在处理您的操作，请勿关闭当前页面</span>
      </div>
      <Table :columns="statusColumn" max-height="600" :data="statusList" border>
        <template slot="procSts" slot-scope="{ row }">
          <span :class="'status-' + row.procSts"
            >{{ procStsObj[row.procSts]
            }}{{ row.procSts === 3 ? `(${row.msg})` : '' }}</span
          >
        </template>
      </Table>
    </Modal>
    <Modal
      v-model="tipsModalShow"
      :mask-closable="false"
      title="提示"
      :footer-hide="true"
      width="700"
    >
      <div class="main">
        <div>
          设置成功：<span class="color-blue">{{ successResult.length }}</span
          >个，失败：<span class="color-red">{{ failResult.length }}</span> 个
        </div>
        <h2 v-if="failResult.length" style="padding: 8px 0">
          调课失败的班级信息
        </h2>
        <ul>
          <li
            v-for="(item, index) in failResult"
            :key="index"
            style="margin-bottom: 6px"
          >
            <p>
              {{ item.classroomName }} （班级ID{{ item.classroomId }}）
              <span class="color-red">原因：{{ item.msg }}</span>
            </p>
          </li>
        </ul>
      </div>
      <div class="btn-box">
        <Button type="primary" @click="handleCfm">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { timeToStr, timeToYearStr } from '@/utils/utils.js';
import axios from 'axios';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
export default {
  props: {
    schoolId: {
      type: String,
      default: ''
    },
    searchData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      showLoadingModal: false,
      statusColumn: [
        {
          title: '课程班级名称',
          key: 'classroomName',
          minWidth: 140
        },
        {
          title: '班级ID',
          key: 'classroomId',
          minWidth: 220
        },
        {
          title: '原上课时间',
          key: 'beforeTime',
          minWidth: 250
        },
        {
          title: '调整至上课时间',
          key: 'adjustTime',
          minWidth: 250
        },
        {
          title: '状态',
          slot: 'procSts',
          minWidth: 120
        }
      ], // 进度列表表头
      statusList: [],
      tipsModalShow: false,
      failResult: [], // 调班失败的列表
      successResult: [], // 调班成功列表
      source: null,
      procStsObj: {
        0: '分班中',
        1: '已完成',
        2: '分班中',
        3: '分班失败'
      } // 0-待执行 1-完成 2-进行中 3-失败
    };
  },
  computed: {
    // 在执行中的任务的id
    batchIds() {
      const list = this.statusList.filter(item => {
        return item.procSts === 0 || item.procSts === 2;
      });
      return list.map(item => {
        return item.batchId;
      });
    }
  },
  methods: {
    // 打开任务进度弹窗
    openLoadingModal(paramsData) {
      this.showLoadingModal = true;
      this.getTaskList(paramsData);
    },
    closeLoadingModal() {
      this.showLoadingModal = false;
    },
    getModalChange(status) {
      if (!status) {
        this.handleCancel();
        this.$emit('handleSure');
      }
    },
    // 导出-进度条
    handleCancel() {
      this.source ? this.source.cancel('取消请求') : '';
    },
    // 获取任务列表
    async getTaskList(paramsData) {
      const params = {
        busiCode: 2,
        schoolIdList: [this.schoolId],
        exeFlag: 1, // 是否可执行 1-是 0-否
        pageSize: 1000,
        pageNo: 1,
        yearCode: this.searchData.yearCode,
        termCode: this.searchData.termCode,
        ...paramsData
      };
      const res = await courseSchedulCenter.getTaskStatusListApi(params);
      if (res.status === 200) {
        const branchIds = [];
        this.statusList = [];
        this.statusList = res.message.list.map(item => {
          if (item.batchProcData.procSts === 0 || item.batchProcData.procSts === 2) {
            branchIds.push(item.batchProcData.batchId);
          }
          const beforeTime = item.properties && item.properties.beforeBeginTime ? `${timeToYearStr(item.properties.beforeBeginTime)} （${timeToStr(item.properties.beforeBeginTime)} - ${timeToStr(item.properties.beforeEndTime)}）` : '-';
          const adjustTime = item.properties && item.properties.beginTime ? `${timeToYearStr(item.properties.beginTime)} （${timeToStr(item.properties.beginTime)} - ${timeToStr(item.properties.endTime)}）` : '-';
          return {
            ...item.batchProcData,
            ...item.properties,
            beforeTime,
            adjustTime,
            msg: item.batchProcData.procSts === 3 ? item.batchProcData.lineData3 : ''
          };
        });
        if (branchIds.length > 0) {
          this.getTaskProgressList(1, branchIds);
        } else {
          this.dealResult();
        }
      }
    },
    // 获取任务列表进度
    async getTaskProgressList(type, batchIds) {
      const params = {
        batchIds: type ? batchIds : this.batchIds, // 任务id
        returnThreshold: 100 // 默认全部完成返回，百分比
      };
      this.source = axios.CancelToken.source();
      const res = await courseSchedulCenter.getTaskProgressApi(params, this.source.token);
      this.source = null;
      if (res.status === 200) {
        const obj = {};
        res.message.forEach(item => {
          item.procSts = item.prcSts;
          obj[item.batchId] = item;
        });
        this.statusList = this.statusList.map(item => {
          if (obj[item.batchId]) {
            return { ...item, ...obj[item.batchId] };
          } else {
            return { ...item };
          }
        });
        this.batchIds.length > 0 ? this.getTaskProgressList() : this.dealResult();
      }
    },
    dealResult() {
      this.failResult = [];
      this.successResult = [];
      this.statusList.forEach(item => {
        if (item.procSts === 1) {
          this.successResult.push(item);
        } else {
          this.failResult.push(item);
        }
      });
      // this.closeLoadingModal();
      this.openTipsModal();
      this.closeLoadingModal();
    },
    // 打开任务结束的结果提示弹窗
    openTipsModal() {
      this.tipsModalShow = true;
    },
    handleCfm() {
      this.tipsModalShow = false;
      // this.$emit('handleSure');
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-box {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 16px;
  }
}
p {
  line-height: 25px;
  span {
    color: red;
  }
}
.status-1 {
  color: #444;
}
.status-0 {
  color: #488ffa;
}
.status-2 {
  color: #488ffa;
}
.status-3 {
  color: rgb(212, 0, 37);
}
.modal-text {
  margin-bottom: 16px;
}
.loading-icon {
  animation: circletrun 1s linear infinite;
}
@keyframes circletrun {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(0.5turn);
  }
  100% {
    transform: rotate(1turn);
  }
}
</style>
